import {
	HStack,
	VStack,
	Text,
	IconDotOutline,
} from '@montel/montelpro-shared-components-v2';
import { GeoNode } from 'domain/subscription/interfaces/Subscription';
import styled from 'styled-components';
import { geoNodeSort } from 'utils/geoNodeHelpers';

export const Area: React.FC<{ area: GeoNode }> = ({ area }) => (
	<VStack gap="sm">
		<HStack key={area.code}>
			{area.name}
			<Text color="textSubtle">({area.code})</Text>
		</HStack>
		{area.children?.length
			? area.children
					.sort(geoNodeSort)
					.map((child) => (
						<ChildArea depth={1} key={child.code} area={child} />
					))
			: null}
	</VStack>
);

const ChildArea: React.FC<{ area: GeoNode; depth: number }> = ({
	area,
	depth,
}) => (
	<StyledChildArea depth={depth} gap="sm">
		<HStack key={area.code} align="center">
			<IconDotOutline size="xs" color="textSubtle" />
			{area.name}
			<Text color="textSubtle">({area.code})</Text>
		</HStack>
		{area.children?.length
			? area.children.map((child) => (
					<ChildArea
						depth={depth + 1}
						key={child.code}
						area={child}
					/>
			  ))
			: null}
	</StyledChildArea>
);

const StyledChildArea = styled(VStack)<{ depth: number }>`
	padding-left: ${(props) => (props.depth - 1) * 24}px;
`;
